import _ from 'underscore';
import $ from 'jquery';

export default class UserManageContacts {
  constructor($scope, UserContactService, UserService, PaginationService) {
    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '800px'
    };

    function set_user_company_autocomplete(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company(null, request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.filter.user_id = ui.item.id;
          $scope.$apply();
        }
      });
    }

    $scope.load_data = function() {
      $scope.select_all = false;
      $scope.loading = true;
      UserContactService.get($scope.filter).success(function(data) {
        $scope.contacts = data.contacts;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.loading = false;
      });
    };

    $scope.load_count_data = function() {
      UserContactService.get_campaign_status_counts().success(function(data) {
        $scope.active = data.active;
        $scope.unregistered = data.unregistered;
        $scope.bounced = data.bounced;
        $scope.on_probation = data.on_probation;
        $scope.on_probation_expired = data.on_probation_expired;
      });
    };

    $scope.mass_update_status = function(campaign_status) {
      var contacts = _.where($scope.contacts, {
        checked: true
      });

      if (contacts.length === 0) {
        alert('Please select at least one contact!');
        return;
      }

      UserContactService.mass_update_contact_campaign_status(_.pluck(contacts, 'id'), campaign_status).success(function(data) {
        if (data.success) {
          $scope.load_data();
          $scope.load_count_data();
        }
      });
    };

    $scope.init_filter = function() {
      $scope.user_company = null;
      $scope.filter = {
        page: 1,
        per_page: 50,
        user_id: null,
        email: null,
        first_name: null,
        last_name: null,
        phone: null,
        campaign_status: null,
        probation_expire_status: null,
        business_relation: null,
        has_categories: null,
        countries: [],
        date_from: null,
        date_to: null
      };
    };

    $scope.set_preset_filter = function(campaign_status, probation_expired) {
      $scope.filter.campaign_status = campaign_status;
      if (probation_expired) {
        $scope.filter.probation_expire_status = 1;
      } else if (campaign_status !== 4 || !probation_expired) {
        $scope.filter.probation_expire_status = null;
      }
    };

    $scope.show_contact_details = function(user_contact) {
      $scope.$broadcast('show_user_contact_notifications', {
        user_contact: user_contact
      });
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

    $scope.check_contacts = function() {
      _.each($scope.contacts, function(c) {
        c.checked = $scope.select_all;
      });
    };

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.business_relations = [
      {
        id: 0,
        title: 'Unqualified Lead'
      },
      {
        id: 1,
        title: 'Qualified Lead'
      },
      {
        id: 2,
        title: 'Contact'
      },
      {
        id: 3,
        title: 'Customer'
      },
      {
        id: 4,
        title: 'Corporate Supplier'
      }
    ];

    $scope.has_categories_options = [
      {
        id: 1,
        title: 'Yes'
      },
      {
        id: 2,
        title: 'No'
      },
    ];

    $scope.probation_end_options = [
      {
        id: 1,
        title: 'Yes'
      },
      {
        id: 2,
        title: 'No'
      },
    ];

    $scope.init = function() {
      $scope.contacts = [];
      $scope.pagination = {};
      $scope.campaign_statuses = window.campaign_statuses;
      set_user_company_autocomplete($('input.user_company'));
      $scope.init_filter();
      $scope.load_data();
      $scope.load_count_data();
    };

    $scope.init();

  }
}

UserManageContacts.$inject = ['$scope', 'UserContactService', 'UserService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-manage-contacts.ctrl.js